import { Injectable } from '@angular/core'
import httpInstance from '../../utils/http-instance'
import type { AxiosInstance } from 'axios'
import { environment } from '../../../environments/environment'

import { EStorageType } from '@pichincha/angular-sdk/auth'
import { storage } from '@pichincha/angular-sdk/storage'
import { EVENT_NAMES } from '../../utils/events'
@Injectable({
  providedIn: 'root',
})
export class JwtService {
  private http: AxiosInstance

  storage = storage({
    storageType: EStorageType.SESSION,
    secretKey: environment.storage.key,
  })

  constructor() {
    this.http = httpInstance
  }

  public async disableJwt() {
    const jwt = this.storage.get(EVENT_NAMES.auth)?.jwt || ''
    await this.http.post(environment.jwtService.url, { token: jwt })
  }
}
